module.exports = __webpack_public_path__ + "img/user.293455d3.svg";